import Box from '@mui/material/Box'
import { useSelector } from 'react-redux'
import { ENTITY_TYPES, LocationDTO } from '@sales-center/common'
import { TabPanel } from '@sales-center/components'
import React, { useCallback, useState } from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { useLoadEntityLocationsOnMount } from '@user/store/entityLocations'
import CircularProgress from '@mui/material/CircularProgress'
import { useAttachmentUpload } from './hooks'

import {
  IAttachmentToAgreementDTO,
  selectAllAttachments,
  useGetAttachmentsOnMount,
} from '@user/store/attachments'
import { SaleCenterAttachments } from './SaleCenterAttachments'
import { LocationAttachments } from './LocationAttachments'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
  canUpdate: boolean
  onSelectionComplete?: (attachments: IAttachmentToAgreementDTO[]) => void
  currentServiceLocation?: LocationDTO
}

export function AttachmentsDrawerContents(props: Props) {
  const { entityId, entityType, onSelectionComplete } = props

  const { openFileSelect, getInputProps, handleFilesAdded } =
    useAttachmentUpload(props)

  const [tabIndex, setTabIndex] = useState<number>(0)

  const attachmentStatus = useGetAttachmentsOnMount(
    entityId,
    entityType === ENTITY_TYPES.Lead,
  )

  const attachmentsLoading = attachmentStatus === 'pending'

  //stop this on from triggering Agreement attachments (triggering on top level)
  const locationStatus = useLoadEntityLocationsOnMount(
    entityId,
    entityType,
    onSelectionComplete ? false : true,
  )
  const locationsLoading = locationStatus === 'pending'

  const attachments = useSelector(selectAllAttachments)

  const handleTabChange = useCallback(
    (_, value: number) => setTabIndex(value),
    [],
  )

  return (
    <Box>
      <Tabs
        onChange={handleTabChange}
        value={tabIndex}
        variant="fullWidth"
        indicatorColor="primary"
        sx={(theme) => ({
          minHeight: theme.spacing(4.3),
          px: 2,
        })}
      >
        <Tab
          label={`Sales Center Attachments (${attachments.length})`}
          value={0}
          sx={(theme) => ({
            minHeight: theme.spacing(4.2),
          })}
          data-test-id="sales-center-attachments-tab"
        />
        <Tab
          label="Location Documents"
          value={1}
          sx={(theme) => ({
            minHeight: theme.spacing(4.2),
          })}
          data-test-id="location-documents-tab"
        />
      </Tabs>
      <TabPanel value={0} tab={tabIndex}>
        {attachmentsLoading ? (
          <Box display="flex" height={'30rem'}>
            <CircularProgress style={{ margin: 'auto' }} />
          </Box>
        ) : (
          <SaleCenterAttachments
            {...props}
            attachments={attachments}
            openFileSelect={openFileSelect}
            handleFilesAdded={handleFilesAdded}
          />
        )}
      </TabPanel>
      {/* ========== L O C A T I O N   D O C U M E N T S ========== */}
      <TabPanel value={1} tab={tabIndex}>
        {locationsLoading ? (
          <Box display="flex" height={'30rem'}>
            <CircularProgress style={{ margin: 'auto' }} />
          </Box>
        ) : (
          <LocationAttachments {...props} />
        )}
      </TabPanel>
      <input {...getInputProps()} />
    </Box>
  )
}
